import { getStudySessionInstructor } from 'my-core/study-session-utils';

import mockExamBannerImg from 'images/product-illustrations/on-demand-mock-exam_long.svg';
import mockExamSquareImg from 'images/product-illustrations/on-demand-mock-exam_square.svg';

export const ON_DEMAND_MOCK_CONFIG = {
  slug: 'on-demand-mock',
  key: 'on_demand_mock',
  label: 'On-Demand Mock Exam',
  description:
    'A realistic, online mock exam based on past exams from your course. Includes detailed step-by-step solutions from our expert instructors.',
  image: mockExamSquareImg,
  banner: mockExamBannerImg,
  color: 'purple',
  inclusions: [
    {
      key: 'exam',
      label: 'On-Demand Exam',
      description: 'Take exam whenever you have time.',
    },
    {
      key: 'solutions',
      label: 'Detailed Solutions',
      description: 'Wizeprep instructors break down the answers to each question.',
    },
  ],
};

export function findAssessmentWithContents(assessments, assessmentId) {
  const curDate = new Date();
  const assessmentsWithContents = assessments.filter(a => a.contents);
  return (
    (assessmentId && assessmentsWithContents.find(a => a.id === assessmentId)) ||
    assessmentsWithContents.find(a => new Date(a.date) > curDate) ||
    assessmentsWithContents[0]
  );
}

export function getWeeklyBundleGroupings(studySessions) {
  const [otherSessions, weeklySessions] = studySessions.reduce(
    (mem, ss) => mem[ss.type === 'weekly_tutorial' ? 1 : 0].push(ss) && mem,
    [[], []],
  );
  const [freeWeeklies, weeklyBundleGroupings] = weeklySessions.reduce(
    (mem, ss) => (ss.price ? mem[1].push([ss]) : mem[0].push(ss)) && mem,
    [[], []],
  );
  if (!weeklyBundleGroupings.length && freeWeeklies.length) weeklyBundleGroupings.push([]);
  freeWeeklies.forEach(ss => {
    const instructorId = getStudySessionInstructor(ss)?.id;
    const bundleGrouping =
      weeklyBundleGroupings.find(group => getStudySessionInstructor(group[0])?.id === instructorId) ||
      weeklyBundleGroupings[0];
    bundleGrouping.push(ss);
  });

  return {
    otherSessions,
    weeklyBundleGroupings,
  };
}
